"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "connect", {
  enumerable: true,
  get: function get() {
    return _connect["default"];
  }
});
Object.defineProperty(exports, "createStore", {
  enumerable: true,
  get: function get() {
    return _createStore["default"];
  }
});
Object.defineProperty(exports, "disconnect", {
  enumerable: true,
  get: function get() {
    return _disconnect["default"];
  }
});
Object.defineProperty(exports, "markActivity", {
  enumerable: true,
  get: function get() {
    return _markActivity["default"];
  }
});
Object.defineProperty(exports, "postActivity", {
  enumerable: true,
  get: function get() {
    return _postActivity["default"];
  }
});
Object.defineProperty(exports, "sendEvent", {
  enumerable: true,
  get: function get() {
    return _sendEvent["default"];
  }
});
Object.defineProperty(exports, "sendFiles", {
  enumerable: true,
  get: function get() {
    return _sendFiles["default"];
  }
});
Object.defineProperty(exports, "sendMessage", {
  enumerable: true,
  get: function get() {
    return _sendMessage["default"];
  }
});
Object.defineProperty(exports, "sendMessageBack", {
  enumerable: true,
  get: function get() {
    return _sendMessageBack["default"];
  }
});
Object.defineProperty(exports, "sendPostBack", {
  enumerable: true,
  get: function get() {
    return _sendPostBack["default"];
  }
});
Object.defineProperty(exports, "setDictateInterims", {
  enumerable: true,
  get: function get() {
    return _setDictateInterims["default"];
  }
});
Object.defineProperty(exports, "setDictateState", {
  enumerable: true,
  get: function get() {
    return _setDictateState["default"];
  }
});
Object.defineProperty(exports, "setLanguage", {
  enumerable: true,
  get: function get() {
    return _setLanguage["default"];
  }
});
Object.defineProperty(exports, "setSendBox", {
  enumerable: true,
  get: function get() {
    return _setSendBox["default"];
  }
});
Object.defineProperty(exports, "setSendTimeout", {
  enumerable: true,
  get: function get() {
    return _setSendTimeout["default"];
  }
});
Object.defineProperty(exports, "setSendTyping", {
  enumerable: true,
  get: function get() {
    return _setSendTyping["default"];
  }
});
Object.defineProperty(exports, "setSendTypingIndicator", {
  enumerable: true,
  get: function get() {
    return _setSendTypingIndicator["default"];
  }
});
Object.defineProperty(exports, "startDictate", {
  enumerable: true,
  get: function get() {
    return _startDictate["default"];
  }
});
Object.defineProperty(exports, "startSpeakingActivity", {
  enumerable: true,
  get: function get() {
    return _startSpeakingActivity["default"];
  }
});
Object.defineProperty(exports, "stopDictate", {
  enumerable: true,
  get: function get() {
    return _stopDictate["default"];
  }
});
Object.defineProperty(exports, "stopSpeakingActivity", {
  enumerable: true,
  get: function get() {
    return _stopSpeakingActivity["default"];
  }
});
Object.defineProperty(exports, "submitSendBox", {
  enumerable: true,
  get: function get() {
    return _submitSendBox["default"];
  }
});
exports.version = exports.Constants = void 0;

var _connect = _interopRequireDefault(require("./actions/connect"));

var _createStore = _interopRequireDefault(require("./createStore"));

var _disconnect = _interopRequireDefault(require("./actions/disconnect"));

var _markActivity = _interopRequireDefault(require("./actions/markActivity"));

var _postActivity = _interopRequireDefault(require("./actions/postActivity"));

var _sendEvent = _interopRequireDefault(require("./actions/sendEvent"));

var _sendFiles = _interopRequireDefault(require("./actions/sendFiles"));

var _sendMessage = _interopRequireDefault(require("./actions/sendMessage"));

var _sendMessageBack = _interopRequireDefault(require("./actions/sendMessageBack"));

var _sendPostBack = _interopRequireDefault(require("./actions/sendPostBack"));

var _setDictateInterims = _interopRequireDefault(require("./actions/setDictateInterims"));

var _setDictateState = _interopRequireDefault(require("./actions/setDictateState"));

var _setLanguage = _interopRequireDefault(require("./actions/setLanguage"));

var _setSendBox = _interopRequireDefault(require("./actions/setSendBox"));

var _setSendTimeout = _interopRequireDefault(require("./actions/setSendTimeout"));

var _setSendTyping = _interopRequireDefault(require("./actions/setSendTyping"));

var _setSendTypingIndicator = _interopRequireDefault(require("./actions/setSendTypingIndicator"));

var _startDictate = _interopRequireDefault(require("./actions/startDictate"));

var _startSpeakingActivity = _interopRequireDefault(require("./actions/startSpeakingActivity"));

var _stopDictate = _interopRequireDefault(require("./actions/stopDictate"));

var _stopSpeakingActivity = _interopRequireDefault(require("./actions/stopSpeakingActivity"));

var _submitSendBox = _interopRequireDefault(require("./actions/submitSendBox"));

var ActivityClientState = _interopRequireWildcard(require("./constants/ActivityClientState"));

var DictateState = _interopRequireWildcard(require("./constants/DictateState"));

var Constants = {
  ActivityClientState: ActivityClientState,
  DictateState: DictateState
};
exports.Constants = Constants;
var version = "4.4.2";
exports.version = version;